export const ShuffleObject = (obj: Record<string, string>) => {
  return Object.fromEntries(
    Object.keys(obj)
      .sort(() => Math.random() - 0.5)
      .map((key) => [key, obj[key]])
  );
};
